var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pluginSlot)?_c('div',{staticClass:"u-mb2"},[_c(_vm.contentComponent,{ref:"pluginContent",tag:"component",attrs:{"context":_vm.context}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }